import React, { useMemo } from 'react'
import Dropdown from 'core/elements/dropdown'
import withProgress from 'core/components/progress/withProgress'
import useListAction from 'core/hooks/useListAction'
import { listFlavors } from './actions'
import { flavorsSelector } from './selectors'
import { useSelector } from 'react-redux'
import GlobalDropdownWithSearch from 'core/elements/dropdown/GlobalDropdownWithSearch'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

interface FlavorPicklistProps {
  disabled?: boolean
  name?: string
  label?: string
  includeNoneOption?: boolean
  includeAllOption?: boolean
  compact?: boolean
  onChange: (value: string) => void
  value: string
  width?: number
  align?: 'left' | 'right'
  [key: string]: any
}

export default function FlavorPicklist({
  disabled = false,
  name = 'flavor',
  label = 'Flavor',
  includeNoneOption = false,
  includeAllOption = false,
  compact = true,
  onChange,
  value,
  width = 180,
  align = 'right',
  ...rest
}: FlavorPicklistProps) {
  const { loading } = useListAction(listFlavors)
  const flavors = useSelector(flavorsSelector)

  const items = useMemo(() => {
    const flavorOptions = flavors.map((flavor) => ({
      label: flavor.name,
      value: flavor.id,
    }))

    const result = []
    if (includeAllOption) {
      result.push({ label: 'All', value: 'all' })
    }
    if (includeNoneOption) {
      result.push({ label: '-- None --', value: '' })
    }
    return [...result, ...flavorOptions]
  }, [flavors, includeNoneOption, includeAllOption])

  return compact ? (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={items}
    />
  ) : (
    <GlobalDropdownWithSearch
      label={label}
      items={items}
      loading={loading}
      onChange={(item) => onChange(item.value)}
      value={value}
      showLabelOnTop
      align={align}
      disabled={disabled}
      width={width}
    />
  )
}
